import * as React from "react"

export const Plus: React.FC = p => (
    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...p}>
        <path d="M0 8H16" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 0L8 16" stroke="currentColor" strokeWidth="1.5" />
    </svg>
)
